/**
 * 创建websoket
 *
 */
import Tool from '@/assets/js/utils.js'
import $store from '@/store.js'
import SocketApi from '@/assets/js/websocket'
let protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://' // 获取协议
// TODO: 需要校验用户是否登录
const isLogin = true
export const createWebsocket = {
  pageRequest (type, key) {
    let dataRequest = {
      url: `${protocol}${$store.state.common.baseUrl.wsBaseUrl}/pageRequest?taskId=${Tool.return32Str()}_q_${$store.state.common.baseUrl.authServerName}`,
      sendHeart: true
    }
    // 初始化

    if (type == 'off' && this.pageRequests) {
      this.pageRequests.off() // 关闭
    } else if (type == 'stop' && this.pageRequests) {
      this.pageRequests.stop(key)
    } else {
      if ($store.state.common.baseUrl.wsBaseUrl && isLogin) {
        this.pageRequests = new SocketApi(dataRequest)
        this.pageRequests.init()
      }
    }
    $store.state.websocket.pageRequest = this.pageRequests
    window.pageRequest = this.pageRequests
  },
  // 新的websocket用来获取R的信息
  pageRWebsocket (type, key, needSendHeart) {
    let dataRequest = {
      url: `${protocol}${$store.state.common.baseUrl.wsBaseUrl}/pageRWebsocket?taskId=${Tool.return32Str()}_q_${$store.state.common.baseUrl.authServerName}`,
      sendHeart: true
    }
    if (type == 'off' && this.pageRWebsockets) {
      this.pageRWebsockets.off() // 关闭
    } else if (type == 'stop' && this.pageRWebsockets) {
      this.pageRWebsockets.stop(key)
    } else {
      if ($store.state.common.baseUrl.wsBaseUrl && isLogin) {
        this.pageRWebsockets = new SocketApi(dataRequest)
        this.pageRWebsockets.init()
      }
    }
    $store.state.websocket.pageRWebsocket = this.pageRWebsockets
  },
  deviceChange (type, key) {
    let dataWebsocket = {
      url: `${protocol}${$store.state.common.baseUrl.wsBaseUrl}/deviceChange?taskId=${Tool.return32Str()}_q_${$store.state.common.baseUrl.authServerName}`
    }
    // 初始化
    if (type == 'off' && this.deviceChanges) {
      this.deviceChanges.off() // 关闭
    } else if (type == 'stop' && this.deviceChanges) {
      this.deviceChanges.stop(key)
    } else {
      this.deviceChanges = new SocketApi(dataWebsocket)
      this.deviceChanges.init()
    }
    $store.state.websocket.deviceChange = this.deviceChanges
  },
  pageAnyWheresocket (type, key, peerId) {
    let dataWebsocket = {
      // ws://cc-ms-dev.tvunetworks.com/ws/anywhere/ef8c90df6a510ac7
      url: `${protocol}${$store.state.common.baseUrl.wsBaseUrl}/anywhere/${peerId}?math=${Math.random()}_${$store.state.common.baseUrl.authServerName}`
    }
    // 初始化
    if (type == 'off' && this.pageAnyWheresockets) {
      this.pageAnyWheresockets.off() // 关闭
    } else if (type == 'stop' && this.pageAnyWheresockets) {
      this.pageAnyWheresockets.stop(key)
    } else {
      this.pageAnyWheresockets = new SocketApi(dataWebsocket)
      this.pageAnyWheresockets.init()
    }
    let newWebsocket = $store.state.websocket
    newWebsocket.pageAnyWheresocket = this.pageAnyWheresockets
    $store.commit('websocket', newWebsocket)
  },
  pageRPSSocket (type, key) {
    const dataRequest = {
      url: `${protocol}/${$store.state.common.baseUrl.wsBaseUrl}/pageSerBusRequest?taskId=${Tool.return32Str()}_${$store.state.common.baseUrl.authServerName}&businessId=rps_one_change`,
      sendHeart: true,
      key: 'RPSWebsocket',
      success: (e) => {
        let data = e.data && JSON.parse(e.data)
        $store.state.realRPSInfo = data
      }
    }
    // 初始化
    if (type == 'off' && this.pageRPSSockets) {
      this.pageRPSSockets.off() // 关闭
      // $store.state.websocket.BehaviorWebsocket = null
    } else if (type == 'stop' && this.pageRPSSockets) {
      this.pageRPSSockets.stop(key)
    } else {
      // 重建前先关旧实例，避免调用方漏关时覆盖引用留下僵尸连接/心跳 Worker（CC-2254 防御）
      if (this.pageRPSSockets) this.pageRPSSockets.off()
      this.pageRPSSockets = new SocketApi(dataRequest)
      this.pageRPSSockets.init()
    }
    $store.state.websocket.pageRPSSockets = this.pageRPSSockets
  },
  pageSerBusRequest (type, key) {
    let dataRequest = {
      url: `${protocol}/${$store.state.common.baseUrl.wsBaseUrl}/pageSerBusRequest?taskId=${Tool.return32Str()}_${$store.state.common.baseUrl.authServerName}&businessId=${localStorage.getItem('userId')}&notCheckUser=true`,
      sendHeart: true
    }
    // 初始化

    if (type == 'off' && this.pageSerBusRequestWs) {
      this.pageSerBusRequestWs.off() // 关闭
    } else if (type == 'stop' && this.pageSerBusRequestWs) {
      this.pageSerBusRequestWs.stop(key)
    } else {
      if ($store.state.common.baseUrl.wsBaseUrl && isLogin) {
        // 如果获取到url 并且获取到session之后才可以创建websocket
        this.pageSerBusRequestWs = new SocketApi(dataRequest)
        this.pageSerBusRequestWs.init()
      }
    }
    $store.state.websocket.pageSerBusRequest = this.pageSerBusRequestWs
  }
}
export default {
  install: function (vm) {
    vm.prototype.$createWebsocket = createWebsocket
  }
}
